import CancelItemRuleRequest from './cancel-item-rule.request';

export default class CancelContractGroupItemRequest {
  contractId: string;

  customerName: String;

  contractNumber: String;

  contractExternalId: String;

  rules?: CancelItemRuleRequest[] = [];

  constructor(obj: any = {}) {
    this.contractId = obj.contractId || '';
    this.customerName = obj.customerName || '';
    this.contractNumber = obj.contractNumber || '';
    this.contractExternalId = obj.contractExternalId || '';
    this.rules = obj.rules ? CancelItemRuleRequest.ofList(obj.rules) : [];
  }

  public static of(obj: any = {}): CancelContractGroupItemRequest {
    return new CancelContractGroupItemRequest(obj || {});
  }

  public static ofList(obj: any[]): CancelContractGroupItemRequest[] {
    return obj.map(this.of);
  }
}
